<template>
  <div class="xero-wrap xero-wrap-mobile">
      <div class="logo"></div>
      <div class="content">
          <h1>Your account has been successfully registered.</h1>
          <h2>Please click the button below to log in to the peiso
            <span>Venue Portal.</span>
          </h2>
          <button @click="goToDashboard()">Go to dashboard</button>
          <!-- <button @click="goToLogin()">Login to Peiso</button> -->
          <h3>You may change your password anytime in the Peiso Venue Portal.</h3>
          <p>If you have trouble logging in, contact Peiso for support at <a href="mailto:support@peiso.com.au">support@peiso.com.au</a></p>
      </div>
  </div>
</template>

<script> 
export default {
  name: 'login',
  data () {
    return {
    }
  },
  methods: {
    goToLogin() {
      sessionStorage.removeItem('request_params') 
      this.$router.replace('/login')
    },
    goToDashboard() {
      sessionStorage.removeItem('request_params') 
      this.$router.replace('/dashboard')
    }
  },  
  created () {
      // if (!sessionStorage.getItem('request_params')) {
      //   this.$router.replace('/welcome')
      // }
  },
}
</script>

<style lang="scss" scoped>
@import 'static/scss/fonts/fonts';
@import 'static/scss/colors';
@import 'static/scss/media-queries';
.content{
    width: 100%;
    box-sizing: border-box;
    background-color: var(--background-color-4);
    padding: 120px 100px 134px 120px;
    h1{
        @include pingfang-medium-font(30px, 42px, 600, $white) {
            margin-bottom: 40px;
            text-align: center;
        }
    }
    h2{
        @include pingfang-medium-font(24px, 36px, 600, $white) {
            word-break: break-word;
            margin-bottom: 40px;
            text-align: center;
        }

        span {
          display: block;   
          @include mobile-lg {
            display: unset;
          }
        }
    }
    button {
        @include pingfang-medium-font(22px, normal, 600, $white) {
            border: none;
            display: block;
            margin: 0 auto 60px auto;
            cursor: pointer;
            width: 310px;
            height: 50px;
            background: #EA3796;
        }

        @include mobile-lg {
          font-size: 16px;
        }
    }
    h3{
        @include pingfang-medium-font(24px, 33px, 600, $white) {
            padding-top: 30px;
            border-top: 1px solid #5F5F5F;
            margin-bottom: 30px;
            word-break: break-word;
        }
        
        @include mobile-lg {
            font-weight: 400;
        }
    }
    p{
        a{
            color: var(--text-color);
        }
        @include pingfang-medium-font(18px, 25px, 400, $white2) {
            word-break: break-word;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/register/success.vue